<template>
    <div class="process-overview mb-4" :class="{ 'collapsed': !stepsExpanded }">
        <div class="step-header">
            <div class="current-step-indicator" @click="stepsExpanded = !stepsExpanded">
                <strong>Step {{currentStep}} of {{stepDescriptions.length}}:</strong> {{getCurrentStepDescription()}}
            </div>
            <div class="header-actions">
                <b-button variant="outline-primary" size="sm" @click="showTerms" class="terms-button mr-3">
                    <i class="fas fa-file-contract mr-2"></i>View Terms
                </b-button>
                <i class="fas chevron-icon" :class="stepsExpanded ? 'fa-chevron-up' : 'fa-chevron-down'" @click="stepsExpanded = !stepsExpanded"></i>
            </div>
        </div>
        <div class="steps-list" v-show="stepsExpanded">
            <p v-for="(step, index) in stepDescriptions" :key="index"
               :class="[index < stepDescriptions.length - 1 ? 'mb-2' : 'mb-0', { 'current-step': currentStep === index + 1, 'completed-step': currentStep > index + 1 }]">
                <strong>Step {{index + 1}}:</strong> {{step}}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StepIndicator',
    props: {
        currentStep: {
            type: Number,
            required: true
        },
        expanded: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            stepsExpanded: this.expanded
        };
    },
    computed: {
        stepDescriptions() {
            return this.config.steps || [
                'Review agreement details and acknowledge important terms',
                'Verify your personal information (name, address, email, phone)',
                'Provide payment method for payment plan installments',
                'Review your information and consent to electronic signature',
                'Review and sign your agreement'
            ];
        }
    },
    methods: {
        getCurrentStepDescription() {
            return this.stepDescriptions[this.currentStep - 1] || '';
        },
        showTerms() {
            this.$emit('show-terms');
        }
    }
};
</script>

<style lang="scss" scoped>
    .process-overview {
        background: #f8f9fa;
        padding: 15px 20px;
        border-radius: 8px;
        border-left: 4px solid #464577;
        transition: all 0.3s ease;

        &.collapsed {
            padding: 12px 20px;
        }

        .step-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 6px 0;

            .current-step-indicator {
                font-size: 1rem;
                color: #464577;
                cursor: pointer;
                user-select: none;
                flex: 1;

                &:hover {
                    color: #2c2b4a;
                }
            }

            .header-actions {
                display: flex;
                align-items: center;
                gap: 12px;

                .terms-button {
                    font-size: 0.85rem;
                    padding: 6px 12px;
                    border-color: #464577;
                    color: #464577;
                    font-weight: 500;
                    white-space: nowrap;

                    &:hover {
                        background-color: #464577;
                        border-color: #464577;
                        color: white;
                    }

                    i {
                        font-size: 0.8rem;
                    }

                    @media (max-width: 576px) {
                        font-size: 0.75rem;
                        padding: 5px 10px;

                        .mr-1 {
                            margin-right: 0.25rem !important;
                        }
                    }
                }

                .chevron-icon {
                    color: #464577;
                    transition: transform 0.3s ease;
                    cursor: pointer;
                    font-size: 1rem;

                    &:hover {
                        color: #2c2b4a;
                    }
                }
            }
        }

        .steps-list {
            margin-top: 15px;
            padding-top: 15px;
            border-top: 1px solid #dee2e6;
        }

        p {
            font-size: 1rem;
            line-height: 1.2;
            padding: 6px 12px;
            border-radius: 4px;
            transition: all 0.2s ease;

            &.current-step {
                background: #464577;
                color: white;

                strong {
                    color: white;
                }
            }

            &.completed-step {
                background: #d4edda;
                border-left: 3px solid #28a745;
                padding-left: 9px;

                strong {
                    color: #155724;
                }

                &:before {
                    content: '✓ ';
                    color: #28a745;
                    font-weight: bold;
                    margin-right: 6px;
                }
            }
        }
    }
</style>
